module.exports = __webpack_public_path__ + "static/media/louis2.9f3fc47e.mp3";